<template>
  <div v-if="value" class="base-info-popup">
    <div class="base-info-popup__backdrop" @click="close"></div>
    <v-card class="base-info-popup__card border-base dark-border pa-4">
      <div class="text-h6 py-2 text-center">{{ title }}</div>
      <div class="body-2 no-word-break text-center text--secondary">{{ message }}</div>
      <div class="pt-3 d-flex justify-end">
        <BaseButton @click="close">OK</BaseButton>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: false
    },
    title: {
      default: ""
    },
    message: {
      default: ""
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
    }
  }
};
</script>
<style lang="scss">
.base-info-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.base-info-popup__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.base-info-popup__card {
  position: relative;
  width: 100%;
  max-width: 500px;
}
</style>
